<template>
  <div>
    <h3>Diagnostics</h3>
    <div v-if="isSupported" class="diagnostics">
      <danger class="mt-1">
        Enabling diagnostics will result in additional logging information being
        stored locally within the application, and may also negatively affect
        performance. You should only enable this when advised to do so by a
        technician.
      </danger>
      <switch-field
        v-model="enabled"
        id="enable-diagnostics"
        label="Enable Diagnostics"
      />
      <div v-if="enabled">
        <a :href="logUrl" class="btn btn-primary btn-sm mt-1" target="_blank"
          >Open the log</a
        >
      </div>
    </div>
    <div v-else>
      <danger title="Not Supported">
        IndexedDB is required for diagnostic logging. You browser does not
        support IndexedDB. Please upgrade to Microsoft Edge version 79 or later.
      </danger>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Danger from "@/components/common/banners/Danger.vue";
import diagnostics from "@/services/diagnostics/diagnosticsService";
import { openLogPage } from "@/util/urlBuilder";

export default {
  components: { Danger },
  computed: {
    ...mapState({
      diagnosticsEnabled: (state) => state.diagnosticsEnabled,
    }),
    isSupported: function () {
      return diagnostics.isSupported();
    },
    enabled: {
      get: function () {
        return this.diagnosticsEnabled;
      },
      set: function (value) {
        this.enableDiagnostics(value);
      },
    },
    logUrl: function () {
      return openLogPage();
    },
  },
  watch: {
    diagnosticsEnabled: async function (enabled) {
      if (enabled) {
        await diagnostics.enable();
      } else {
        await diagnostics.clear();
      }
    },
  },
  methods: {
    ...mapActions({
      enableDiagnostics: "enableDiagnostics",
    }),
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bold;
}
</style>
